/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import { client, withUnwrap } from '../.kubb/client'
import type { MeGetRolesOptions, MeGetRolesResponses } from '../models/MeGetRoles'
import { meGetRolesResponseSchema } from '../schemas/meGetRolesSchema'

/**
 * @summary All contexts the user can switch into — ORG (individual account = ORG entry with empty id), EDU,
 * EDY365 and STUDENT entries (a user who is both EDU staff and student of the same EDU gets two entries).
 * {@link /api/v4/me/roles}
 */
export function meGetRoles<ThrowOnError extends boolean = true>(
  options: Options<MeGetRolesOptions, ThrowOnError> = {}
): Unwrappable<RequestResult<MeGetRolesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/api/v4/me/roles',
      security: [{ type: 'http', scheme: 'bearer' }],
      validator: { response: meGetRolesResponseSchema },
      ...config,
    }) as Promise<RequestResult<MeGetRolesResponses, ThrowOnError>>
  )
}
